export default {
    namespaced: true,
    state: {
        loading: false,
        processing: false
    },
    mutations: {
        setLoading(state, payload) {
            state.loading = payload;
        },
        start(state) {
            state.loading = true
        },
        stop(state) {
            state.loading = false
        },
    },
    actions: {},
    getters: {}
}
